export default __webpack_public_path__ + "static/media/13_Business-ProductArchitecture-InteriorEschweilerPhotography_M1A7581.6cad0034.jpg";